<db-dialog-wrapper [dialog]="this" [fullScreen]="true" [closeButtonTop]="'24px'" [closeButtonRight]="'30px'">
  <div class="db-available-plugins">
    <div class="db-available-plugins__title">{{'text_addPlugins' | dbText}}</div>

    <div class="db-available-plugins__body">
      <div class="db-available-plugins__filters-bar db-filters-bar" >
        <div></div>
        <div class="db-available-plugins-search-wrap" *ngIf="activeTab !== 'upload' && activeTab !== 'featured-plugins'">
          <db-fc-search-input [formControl]="searchTerm" placeholderTitle="{{'text_searchPlugins' | dbText}}" placeholder="{{'text_searchEllipsis' | dbText}}"></db-fc-search-input>
        </div>
      </div>

      <db-tabs class="db-available-plugins__tabs" [activeTabId]="activeTab" [currentSubscription]="currentSubscription" (onActiveTabChange)="setActiveTab($event)">
        <db-tab-head tabId="10web"><span>{{companyName}}</span></db-tab-head>
        <db-tab-head tabId="upload"><span>{{'text_upload-plugins' | dbText}}</span></db-tab-head>
        <db-tab-head tabId="wordpress"><span>{{'text_wordpress-plugins' | dbText}}</span></db-tab-head>
        <db-tab-head tabId="featured-plugins"><span>{{'text_featured-plugins' | dbText}}</span></db-tab-head>

        <db-tab-content>
          <div class="db-available-plugins__panel db-panel db-panel_flex">
            <div dbCustomScrollbar class="db-panel__body" *ngIf="activeTab !== 'upload'">
              <div class="db-available-plugins__panel-content">
                <div>
                  <div *ngIf="filteredPlugins && filteredPlugins.length && !loading">
                    <div *ngFor="let pluginWithChildren of filteredPlugins">
                      <db-available-plugin class="sl-parent-plugin"
                        [website]="website"
                        [product]="pluginWithChildren.plugin"
                        [hasExtensions]="!!pluginWithChildren.children.length"
                        [userPermissions]="userPermissions"
                        [userSubscriptions]="userSubscriptions"
                        [currentSubscription]="currentSubscription"
                        [activeTab]="activeTab"
                        [companyName]="companyName"
                        (toggled)="onItemToggled(pluginWithChildren.plugin)"
                      ></db-available-plugin>
                      <div class="db-available-plugins__children"
                           [ngClass]="{'db-available-plugins__children_collapsed': !pluginWithChildren.plugin.childrenToggled}"
                           *ngIf="!!pluginWithChildren.children.length"
                      >
                        <db-available-plugin
                          [website]="website"
                          [parent]="pluginWithChildren.plugin"
                          [product]="addon"
                          [userPermissions]="userPermissions"
                          [userSubscriptions]="userSubscriptions"
                          [currentSubscription]="currentSubscription"
                          [activeTab]="activeTab"
                          [companyName]="companyName"
                          (toggled)="onItemToggled(addon, pluginWithChildren.plugin)"
                          *ngFor="let addon of pluginWithChildren.children"
                        ></db-available-plugin>
                      </div>
                    </div>
                    <db-available-plugin *ngIf="activeTab === 'featured-plugins'" class="sl-parent-plugin aaaa"
                        [website]="website"
                        [product]="filteredPlugins[0].plugin"
                        [userPermissions]="userPermissions"
                        [userSubscriptions]="userSubscriptions"
                        [currentSubscription]="currentSubscription"
                        [activeTab]="activeTab"
                        [featuredPlugin]="true"
                        [companyName]="companyName"
                        (toggled)="onItemToggled(filteredPlugins[0].plugin)"
                      ></db-available-plugin>
                  </div>

                  <db-empty-search class="db-available-plugins__empty-search" *ngIf="filteredPlugins && !filteredPlugins.length"></db-empty-search>
                </div>
              </div>
            </div>


              <div class="db-available-plugins__panel-content db-available-plugins__upload-tab" *ngIf="activeTab === 'upload'">
                <file-drop class="db-available-plugins__upload" customstyle="db-available-plugins__upload-drop-zone" (onFileDrop)="onPluginArchiveDrop($event)" *ngIf="activeTab === 'upload'">
                  <div class="db-available-plugins__upload-icon"></div>

                  <ng-container *ngIf="!uploadActivity">
                    <div class="db-available-plugins__upload-title">{{'text_uploadFile' | dbText}}</div>
                    <div class="db-available-plugins__upload-message">{{'text_uploadPluginMessage' | dbText}}</div>
                    <div class="db-available-plugins__upload-button">
                      <label><a class="db-button db-button_info"><span>{{'text_uploadChooseFile' | dbText}}</span></a><input class="sl-upload-file" type="file" (change)="onPluginArchiveSelect($event)"></label>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="uploadActivity && ![ActivityStatus.DONE, ActivityStatus.FAILED].includes(uploadActivity.status)">
                    <div class="db-available-plugins__upload-title">{{'text_installing' | dbText}}</div>
                    <div class="db-available-plugins__upload-message">{{'text_uploadInstallingMessage' | dbText}}</div>
                    <div class="db-available-plugins__upload-progress"><db-progress-bar size="sm" [progressPercent]="uploadActivity?.progress"></db-progress-bar></div>
                  </ng-container>

                  <ng-container *ngIf="uploadActivity?.status === ActivityStatus.DONE">
                    <div class="db-available-plugins__upload-title">{{'text_optimizerOptimizeSuccess' | dbText}}</div>
                    <div class="db-available-plugins__upload-message">{{'text_installSuccess' | dbText}}</div>
                    <div class="db-available-plugins__upload-progress"><db-progress-bar size="sm" state="success" [progressPercent]="100"></db-progress-bar></div>
                  </ng-container>

                  <ng-container *ngIf="uploadActivity?.status === ActivityStatus.FAILED">
                    <div class="db-available-plugins__upload-title">{{'text_uploadFail' | dbText}}</div>
                    <div class="db-available-plugins__upload-message">{{'text_uploadFailMessage' | dbText}}</div>
                    <div class="db-available-plugins__upload-progress"><db-progress-bar size="sm" state="danger" [progressPercent]="100"></db-progress-bar></div>
                    <div class="db-available-plugins__upload-button">
                      <label><a class="db-button db-button_default" (click)="resetUploadState()"><span>{{'text_uploadTryAgain' | dbText}}</span></a></label>
                    </div>
                  </ng-container>
                </file-drop>
              </div>


            <div class="db-available-plugins__actions db-panel__footer" *ngIf="activeTab === '10web'">
              <label *ngIf="userPermissions.canManageContent && !website.isLocalhost">
                <span class="db-fc-checkbox"><input type="checkbox" [formControl]="selectAll" (change)="toggleAllItemsSelected($event.currentTarget.checked)"><span><i class="db-icon db-icon-check"></i></span></span>
                <span class="db-available-plugins__actions-label">{{'text_selectAll' | dbText}}</span>
              </label>

              <div>
                <span class="db-available-plugins__actions-label" *ngIf="selectedPluginsAndAddons && !!selectedPluginsAndAddons.length">{{'text_selectedPluginsCount' | dbText : {selectedPluginsCount: selectedPluginsAndAddons.length} }}</span>
                <a class="db-button db-button_info" (click)="bulkInstallAndActivate()" [ngClass]="{'db-button_disabled': !selectedPluginsAndAddons || !selectedPluginsAndAddons.length}"><span>{{'text_install' | dbText}}</span></a>
              </div>
            </div>

            <db-loading-screen *ngIf="loading"></db-loading-screen>
          </div>
        </db-tab-content>
      </db-tabs>
    </div>
  </div>
</db-dialog-wrapper>
